<template>
  <div>
    <div class="primary darken-1 rounded-lg py-6 px-4 px-md-5">
      <div
        class="white--text text-h6 text-md-h4 text-lg-h4 font-weight-bold"
        v-if="!xs"
      >
        Busca avançada:
      </div>

      <div v-else>
        <v-btn
          @click="expandedFilter = !expandedFilter"
          class="
            transparent
            d-flex
            justify-space-between
            white--text
            text-h6 text-none
            font-weight-bold
            px-0
          "
          depressed
          width="100%"
        >
          {{ expandedFilter ? "Busca avançada:" : "Busca:" }}
          <v-icon size="16">
            {{ expandedFilter ? "fa-caret-up" : "fa-caret-down" }}
          </v-icon>
        </v-btn>
      </div>

      <v-form
        @submit="onSubmit"
        ref="form"
        id="advanced-search"
        class="advanced-search"
      >
        <div v-if="(xs && expandedFilter) || !xs">
          <v-row class="my-0">
            <v-col cols="6" sm="12" class="px-2 px-md-3 py-0">
              <div class="mt-3 mt-lg-4">
                <label
                  class="white--text text-body-1 text-lg-h6 font-weight-regular"
                  for="ref"
                >
                  {{ xs ? `Referência` : `Busca por referência` }}
                </label>

                <v-text-field
                  background-color="white"
                  dense
                  outlined
                  hide-details
                  v-model="ref"
                  placeholder="Ex.: 1234,4321"
                  height="40px"
                  name="ref"
                  class="mt-1 form-control"
                  id="ref"
                ></v-text-field>
              </div>
            </v-col>

            <v-col cols="6" sm="12" class="px-2 px-md-3 py-0">
              <div class="mt-3 mt-lg-4">
                <label
                  class="white--text text-body-1 text-lg-h6 font-weight-regular"
                  for="business"
                >
                  Finalidade
                </label>

                <v-select
                  background-color="white"
                  dense
                  outlined
                  v-model="bussinessModel"
                  :items="business"
                  hide-details
                  multiple
                  height="40px"
                  name="finalidade"
                  placeholder="Todos"
                  class="mt-1 form-control"
                  id="business"
                ></v-select>
              </div>
            </v-col>
          </v-row>

          <v-row class="my-0">
            <v-col cols="6" sm="12" class="px-2 px-md-3 py-0">
              <div class="mt-3 mt-lg-4">
                <label
                  class="white--text text-body-1 text-lg-h6 font-weight-regular"
                  for="type"
                >
                  Tipo de Imóvel
                </label>

                <v-select
                  background-color="white"
                  dense
                  outlined
                  v-model="type"
                  :items="types"
                  hide-details
                  multiple
                  height="40px"
                  name="tipo"
                  placeholder="Todos"
                  class="mt-1 form-control"
                  id="type"
                ></v-select>
              </div>
            </v-col>

            <v-col cols="6" sm="12" class="px-2 px-md-3 py-0">
              <div class="mt-3 mt-lg-4">
                <label
                  class="white--text text-body-1 text-lg-h6 font-weight-regular"
                  for="district"
                >
                  Bairro
                </label>

                <v-select
                  background-color="white"
                  dense
                  outlined
                  v-model="district"
                  :items="districts"
                  hide-details
                  multiple
                  height="40px"
                  name="bairro"
                  placeholder="Todos"
                  class="mt-1 form-control"
                  id="district"
                ></v-select>
              </div>
            </v-col>
          </v-row>

          <v-row class="my-0">
            <v-col cols="6" sm="12" class="px-2 px-md-3 py-0">
              <div class="mt-3 mt-lg-4">
                <label
                  class="white--text text-body-1 text-lg-h6 font-weight-regular"
                  for="garage"
                >
                  Garagem{{ !xs ? `(vagas)` : `` }}
                </label>

                <v-select
                  background-color="white"
                  dense
                  outlined
                  v-model="garage"
                  :items="[
                    { text: 1, value: 1 },
                    { text: 2, value: 2 },
                    { text: 3, value: 3 },
                    { text: 4, value: 4 },
                    { text: 5, value: 5 },
                    { text: `mais que 5`, value: `+5` },
                  ]"
                  hide-details
                  multiple
                  height="40px"
                  name="garagem"
                  placeholder="Todos"
                  class="mt-1 form-control"
                  id="garage"
                ></v-select>
              </div>
            </v-col>

            <v-col cols="6" sm="12" class="px-2 px-md-3 py-0">
              <div class="mt-3 mt-lg-4">
                <label
                  class="white--text text-body-1 text-lg-h6 font-weight-regular"
                  for="bedrooms"
                >
                  Quartos
                </label>

                <v-select
                  background-color="white"
                  dense
                  outlined
                  v-model="bedrooms"
                  :items="[
                    { text: 1, value: 1 },
                    { text: 2, value: 2 },
                    { text: 3, value: 3 },
                    { text: 4, value: 4 },
                    { text: 5, value: 5 },
                    { text: `mais que 5`, value: 6 },
                  ]"
                  hide-details
                  multiple
                  height="40px"
                  name="quartos"
                  placeholder="Todos"
                  class="mt-1 form-control"
                  id="bedrooms"
                ></v-select>
              </div>
            </v-col>
          </v-row>

          <div class="mt-3 mt-lg-4 relative range-slide-price">
            <label
              class="white--text text-body-1 text-lg-h6 font-weight-regular"
              for="bedrooms"
            >
              Faixa de Preço
            </label>

            <div class="d-flex justify-space-between mt-2">
              <div class="white--text text-body-1 font-weight-light">
                {{ formatPrice(priceRangeStart) }}
              </div>
              <div class="white--text text-body-1 font-weight-light">
                {{ formatPrice(priceRangeEnd) }}
              </div>
            </div>

            <v-range-slider
              v-model="priceRange"
              :max="priceMax"
              :min="priceMin"
              step="10000"
              color="secondary"
              hide-details
              height="40"
            >
            </v-range-slider>
          </div>
        </div>
        <div v-else>
          <v-row class="my-0">
            <v-col cols="6" sm="12" class="px-2 px-md-3 py-0">
              <div class="mt-3 mt-lg-4">
                <label
                  class="white--text text-body-1 text-lg-h6 font-weight-regular"
                  for="business"
                >
                  Finalidade
                </label>

                <v-select
                  background-color="white"
                  dense
                  outlined
                  v-model="bussinessModel"
                  :items="business"
                  hide-details
                  multiple
                  height="40px"
                  name="finalidade"
                  placeholder="Todos"
                  class="mt-1 form-control"
                  id="business"
                ></v-select>
              </div>
            </v-col>

            <v-col cols="6" sm="12" class="px-2 px-md-3 py-0">
              <div class="mt-3 mt-lg-4">
                <label
                  class="white--text text-body-1 text-lg-h6 font-weight-regular"
                  for="bedrooms"
                >
                  Quartos
                </label>

                <v-select
                  background-color="white"
                  dense
                  outlined
                  v-model="bedrooms"
                  :items="[
                    { text: 1, value: 1 },
                    { text: 2, value: 2 },
                    { text: 3, value: 3 },
                    { text: 4, value: 4 },
                    { text: 5, value: 5 },
                    { text: `mais que 5`, value: 6 },
                  ]"
                  hide-details
                  multiple
                  height="40px"
                  name="quartos"
                  placeholder="Todos"
                  class="mt-1 form-control"
                  id="bedrooms"
                ></v-select>
              </div>
            </v-col>
          </v-row>
        </div>

        <v-btn
          class="white--text text-h6 font-weight-medium text-none mt-3 mt-lg-5"
          color="secondary"
          width="100%"
          height="40px"
          rounded
          depressed
          type="submit"
        >
          Buscar
        </v-btn>
      </v-form>
    </div>
  </div>
</template>

<script>
import { formatPrice } from "../../utils/formatPrice";

export default {
  data: () => ({
    expandedFilter: false,
    ref: "",
    types: [],
    districts: [],
    priceRangeStart: null,
    priceRangeEnd: null,
    bussinessModel: "",
    type: "",
    district: "",
    garage: "",
    bedrooms: "",
  }),
  computed: {
    business() {
      return this.$rest(`business`).list.map(({ id, title }) => ({
        text: title,
        value: id,
      }));
    },
    filterBusiness() {
      if (!this.business) return "";
      return this.business.filter(
        (item) => item.value === this.businessModel
      )[0].text;
    },
    filters() {
      return this.$route.query;
    },
    priceMax() {
      return 3000000;
    },
    priceMin() {
      return 0;
    },
    priceRange: {
      get() {
        return [this.priceRangeStart, this.priceRangeEnd];
      },
      set(v) {
        this.priceRangeStart = v[0];
        this.priceRangeEnd = v[1];
      },
    },
    xs() {
      return this.$vuetify.breakpoint.xsOnly;
    },
  },
  methods: {
    formatPrice,
    onSubmit(event) {
      event.preventDefault();

      const data = Object.fromEntries(
        new FormData(this.$refs.form.$el).entries()
      );

      if (this.priceRangeStart !== this.priceMin)
        data["min"] = this.priceRangeStart;
      if (this.priceRangeEnd !== this.priceMax)
        data["max"] = this.priceRangeEnd;

      for (let k in data) if (!data[k]) delete data[k];

      this.$emit("search");
      this.$router.push("?" + new URLSearchParams(data).toString());
    },
  },
  watch: {
    priceMax(v) {
      if (!this.priceRangeEnd) this.priceRangeEnd = v;
    },
    priceMin(v) {
      if (!this.priceRangeStart) this.priceRangeStart = v;
    },
    filters() {
      if (this.$route.fullPath == "/imoveis") {
        this.priceRange = [this.priceMin, this.priceMax];
        this.bussinessModel = "";
        this.type = "";
        this.district = "";
        this.garage = "";
        this.bedrooms = "";
      }
    },
  },
  mounted() {
    this.$rest(`categories`)
      .get({ params: { type: "types" } })
      .then((data) => {
        this.types = data.map(({ id, title }) => ({
          text: title,
          value: id,
        }));
      });

    this.$rest(`categories`)
      .get({ params: { type: "districts" } })
      .then((data) => {
        this.districts = data.map(({ id, title }) => ({
          text: title,
          value: id,
        }));
      });

    if (!this.priceRangeStart) this.priceRangeStart = this.priceMax;
    if (!this.priceRangeEnd) this.priceRangeEnd = this.priceMin;
  },
};
</script>

<style lang="scss">
.advanced-search {
  .form-control {
    .v-select__selections {
      color: var(--v-grey-lighten3) !important;
    }
    input {
      color: var(--v-grey-lighten3) !important;
    }
  }
}
</style>
